// extracted by mini-css-extract-plugin
export default {"container":"src-components-Modules-Video-css-module__container--iVpVf","checkboxContainer":"src-components-Modules-Video-css-module__checkboxContainer--eVhjZ"};